import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES, LANGUAGE_CODES } from "models";
import { NewsQueryKeys } from "modules/NewsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import i18n from "utils/i18n";

import type { Article } from "models";

const REFETCH_INTERVAL_FOR_UNREAD_ARTICLES_MS = 3600000;

const sortArticles = (articles: Article[]) =>
  articles.sort((a, b) => (a.publish_date === b.publish_date ? b.id - a.id : (a.publish_date || "") > (b.publish_date || "") ? -1 : 1));

export const useUnreadArticlesQuery = (dealer_location_id: number = 0) => {
  const canListUnreadArticles = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Articles);

  return {
    unreadArticles: useTypedQuery({
      queryKey: NewsQueryKeys.unreadArticles,
      queryFn: async ({ baseUrl, endpoint }) => {
        const language_code = localStorage.getItem("locale") || i18n.language || LANGUAGE_CODES.English;
        const response = await ApiInstance.post(endpoint, { dealer_location_id, language_code }, baseUrl);

        return response.data.articles;
      },
      select: sortArticles,
      enabled: Boolean(dealer_location_id) && canListUnreadArticles,
      refetchInterval: REFETCH_INTERVAL_FOR_UNREAD_ARTICLES_MS
    }).data
  };
};
